import { UsersProfile } from '@/type/profile'
import Basket, { BasketLite } from '@/type/basket'
import React from 'react'

interface ProfileContextInterface {
  profile: UsersProfile | null
  loadingProfile: boolean
  dataLanguagesAvailable: Record<any, any>[]
  profileRefetcher: () => void
  isAuthenticated: boolean
  basket: Basket
  basketLoading: boolean
  loadingRefetchBasket: boolean
  basketAllRefetcher: () => Promise<any>
  shippingIds: Record<any, any>[]
  setShippingIds: (any) => void
  dataCounterProducts: BasketLite
  loadingCounterProducts: boolean
  refetchCounterProducts: () => Promise<void>
  amountMinUsePot?: number
}

const ProfileContext = React.createContext<ProfileContextInterface>({
  profile: null,
  loadingProfile: false,
  dataLanguagesAvailable: [],
  profileRefetcher: () => null,
  isAuthenticated: false,
  basket: null,
  basketLoading: true,
  loadingRefetchBasket: false,
  basketAllRefetcher: async () => Promise.resolve(),
  shippingIds: [],
  setShippingIds: () => null,
  dataCounterProducts: null,
  loadingCounterProducts: false,
  refetchCounterProducts: async () => {},
  amountMinUsePot: 50,
})

export default ProfileContext
